import { Component, OnInit, Input, OnDestroy, ViewChild } from '@angular/core';
import { CheckoutService } from '../checkout.service';
import { NgForm } from '@angular/forms';
import { UIRouter } from '@uirouter/core';
import { CheckoutBasketModel } from '../models/basket.model';
import { Subscription } from 'rxjs';
import { ModalComponent } from '../../global/modal/modal.component';

@Component({
  selector: 'jb-checkout-info',
  templateUrl: './info.component.html',
  styleUrls: [
    './info.component.scss'
  ]
})
export class CheckoutInfoComponent implements OnInit, OnDestroy {
  private basketSub: Subscription;

  public basket: CheckoutBasketModel;
  public greetingsMessage: string = '';
  public firstName: string = '';
  public lastName: string = '';

  @Input()
  public hideItemCount: boolean = false;

  @Input()
  public hideTax: boolean = false;

  @Input()
  public totalType: string = 'gross';

  @ViewChild('modalComponentElement')
  public modalComponentElement: ModalComponent;

  constructor(
    private router: UIRouter,
    private checkoutService: CheckoutService
  ) {
  }

  public ngOnInit() {
    this.basket = this.checkoutService.basket;

    this.basketSub = this.checkoutService
      .basketChange
      .subscribe((basket) => {
        this.basket = basket;
      });
  }

  public ngOnDestroy() {
    this.basketSub.unsubscribe();
  }

  public openGreetingsMessageModal(greetingsMessage: string, firstName: string, lastName: string) {
    if (greetingsMessage.length <= 25) {
      return false;
    }

    this.greetingsMessage = greetingsMessage.replace(/(\\r\\n)|([\r\n])/gmi, '<br>');
    this.firstName = firstName;
    this.lastName = lastName;
    this.modalComponentElement.openModal();
  }

  public trimGreetingsMessage(message: string) {
    message = message.replace(/(\\r\\n)|([\r\n])/gmi, ' ');

    if (message.length > 25) {
      message = `${message.substr(0, 25)}... <i class="ml-2"><u>mehr</u></i>`;
    }

    return message;
  }
}



// WEBPACK FOOTER //
// ./src/app/checkout/info/info.component.ts